/* eslint-disable no-console */
import { io } from 'socket.io-client';
import i18n from 'i18next';
import { connectSocket, UpdateSocketMessage } from '../actions/AuthActions';
import { SOCKET_STATE_CHANGE } from '../constants/ActionTypes';
import { addConfig } from '../actions/ConfigActions';

export const STATE_START = 'STATE_START';
export const STATE_CONNECTING = 'STATE_CONNECTING';
export const STATE_CONNECTED = 'STATE_CONNECTED';
export const STATE_DISCONNECTED = 'STATE_DISCONNECTED';
export const STATE_MAX_EXCEEDED = 'STATE_MAX_EXCEEDED';
export const STATE_LICENSE_EXPIRED = 'STATE_LICENSE_EXPIRED';

const RESPONSE_SUCCESS = 'RESPONSE_SUCCESS';
const RESPONSE_ERROR = 'RESPONSE_ERROR';

const CONNECT = 'connect';
const DISCONNECT = 'disconnect';
const CONNECT_ERROR = 'connect_error';

let socket;

function ReConnected() {
  console.log('*** Reconnect');
  setTimeout(() => {
    socket.connect();
  }, 5000);
}

function Connect(store, { token }) {
  const { config } = store.getState((state) => state.config);

  const { SOCKET_IO, CLOUD_WITH_AUTH, OFFLINE_VERSION } = config;

  console.log('*** connecting...', SOCKET_IO);

  socket = io(SOCKET_IO, {
    transports: ['websocket'],
    reconnection: false,
    path: '/socket',
    query: `token=${token}`,
  });

  if (!SOCKET_IO && OFFLINE_VERSION) {
    store.dispatch(connectSocket({ state: STATE_CONNECTED }));
    store.dispatch(UpdateSocketMessage(undefined)); // necesario para que arranque la app
    return;
  }

  socket
    .on(CONNECT, () => {
      console.log('*** Connected.');
      store.dispatch(connectSocket({ state: STATE_CONNECTED }));
    })
    .on(RESPONSE_SUCCESS, (data) => {
      const url = new URL(window.location.href);
      let xAuthToken = url.searchParams.get('x-auth-token');

      xAuthToken && (data.authorizationHeader = xAuthToken);

      // investigar donde se carga la config cuando es cloud
      if (!CLOUD_WITH_AUTH) store.dispatch(addConfig(data));

      store.dispatch(UpdateSocketMessage(undefined));
    })
    .on(RESPONSE_ERROR, (error) => {
      console.log('*** Response error', error);
      switch (error.type) {
        case 'LICENSE_EXPIRED':
          store.dispatch(UpdateSocketMessage(i18n.t('license.expired')));
          break;

        case 'MAX_CONCURRENT_USERS':
          store.dispatch(UpdateSocketMessage(i18n.t('max.users.exceeded')));
          break;

        default:
          break;
      }
      ReConnected();
    })
    .on(CONNECT_ERROR, (error) => {
      console.log('*** Connecting error', error);
      store.dispatch(connectSocket({ state: STATE_DISCONNECTED }));
      ReConnected();
    })
    .on(DISCONNECT, () => {
      console.log('*** Disconected socket.');
      store.dispatch(connectSocket({ state: STATE_DISCONNECTED }));
      // ReConnected();
    });
}

const SocketIOMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case SOCKET_STATE_CHANGE:
      if (action.payload.state === STATE_CONNECTING) {
        Connect(store, action.payload);
      }
      return next(action);
    default:
      return next(action);
  }
};

export default SocketIOMiddleware;
